<template>
	<section class="Search0002">
		<el-row :gutter="0" class="SearchHead">
			<router-link to="/sp/0002" class="Router__To__Destination"
				><i class="el-icon-close"></i
			></router-link>
			<el-col :span="6">
				<span class="SearchSpan">お知らせ</span>
			</el-col>
			<el-col :span="12">
				<img
					src="../../../assets/image/logo-new.png"
					alt="logo"
					class="ElnetLogo"
				/>
			</el-col>
			<el-col :span="6"></el-col>
		</el-row>
		<!-- <el-row class="SearchBody">
			<el-col  class="ql-editor adminAlertToaster" v-html="userNotice"></el-col>
		</el-row> -->
		<div class="SearchBody">
            <code class="ql-editor adminAlertToaster" v-html="userNotice"></code>
        </div>
	</section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "userNotice0002",
	props: [],
	mounted() {
		this.$store.commit('sp_Situation0001/setThemeLoadCheck', 0);
        this.$store.dispatch('sp_Communication0001/getUserNotice').then(() => {
            this.userNotice = this.getUserNotice;
        })
	},
	data() {
		return {
			userNotice: ''
		};
	},
	methods: {

	},
	computed: {
		...mapGetters("sp_Situation0001", ["getUserNotice"])
	},
	beforeCreate() {
		//Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
	}
};
</script>

<style scoped>
@import "0023.css";
@import "../../../assets/css/customStyle.css";
@import "../../../assets/css/style.css";
</style>
